import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface DetailAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.rfqs.decline
function* declineSaga({ payload }) {
    try {
        const response = yield axios.get(`/companies/rfqs/decline/${payload.id}`)
        if (response.success) {
            yield put(onSuccess({ data: response.result }))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* decline(): any {
    yield takeLatest<DetailAction>(onRequest, declineSaga)
}

export default decline
